import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import TakeNoteBullet from 'src/components/AmexAccountVerificationActionRequiredBox/TakeNoteBullet'
import DividerLineDiv from 'src/components/DividerLineDiv/DividerLineDiv'
import { useTranslate } from 'src/localization/Trns'
import styled, { css } from 'styled-components'

interface AmexAccountVerificationActionRequiredInnerContentProps {
  subtitle: React.ReactNode
  steps: React.ReactElement[]
  endMessage?: React.ReactElement
  takeNoteBullets?: React.ReactElement[]
}

const AmexAccountVerificationActionRequiredInnerContent: React.FC<
  AmexAccountVerificationActionRequiredInnerContentProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const DescriptionDiv = styled.div`
    margin-top: 20px;
  `

  return (
    <>
      <DescriptionDiv>{props.subtitle}</DescriptionDiv>
      <DescriptionDiv>
        <ol
          css={css`
            margin-left: 15px;

            & > *:nth-child(n + 1) {
              margin-top: 20px;
            }
          `}
        >
          {props.steps.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>
      </DescriptionDiv>
      {props.endMessage && (
        <div
          css={css`
            margin-top: 20px;
          `}
        >
          {props.endMessage}
        </div>
      )}
      {props.takeNoteBullets && (
        <>
          <DividerLineDiv
            css={css`
              margin: 40px 0px 12px 0px;
            `}
          />
          <div
            css={css`
              & > *:nth-child(n) {
                margin-bottom: 12px;
              }
            `}
          >
            <div
              css={css`
                ${getFontCss(
                  14,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              {translate('Take Note')}
            </div>
            {props.takeNoteBullets.map((bullet, i) => (
              <TakeNoteBullet
                key={i}
                css={css`
                  ${getFontCss(
                    12,
                    styleConstants.colors.gray_darkest,
                    styleConstants.fontFamilies.regular,
                  )};
                `}
              >
                {bullet}
              </TakeNoteBullet>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default AmexAccountVerificationActionRequiredInnerContent
